module.exports = __webpack_public_path__ + "images/emoji/curry.930073913796ed37e65d.png";